import React from 'react';

import { connect } from 'react-redux';

import { SideBarItems, LevelEditorModeEnum, BlockAppearanceTypes } from '../../shared';
import BlokEditor from './BlokEditor';
import ActionReaction from './ActionReaction';
import ChangeState from './BlokEditor/ChangeState';
import { ReactionAfterwards } from '../../../Game/Level/Blok/ActieReactie';
import LibraryManager from '../../../Game/Base/Library/LibraryManager';
import settings from '../../../settings';

import CircleIconButton from '../Default/CircleIconButton';
import { setActiveSidebarItem } from '../../actions/sideBarActions';
import BackgroundEditor from './BackgroundEditor';

import { newStateObject } from '../../../GameKit/shared';

class SideBar extends React.Component {
    closeSideBar = () => {
        const { sideBar } = this.props;
        if (sideBar.activeItem === SideBarItems.BACKGROUND_COLOR) {
            this.setActiveItem(SideBarItems.BACKGROUND_DRAW);
        } else {
            this.setActiveItem(SideBarItems.ACTIVE);
        }
    };

    setActiveItem = item => {
        const { dispatch } = this.props;

        dispatch(setActiveSidebarItem(item));
    };

    getBlockUIContent = () => {
        const { sideBar, actionReaction, blokEditor } = this.props;

        let activeBlockUrl;
        let activeOtherBlockUrl;

        if (blokEditor.state1Look) {
            if (blokEditor.state1Look.type === BlockAppearanceTypes.TEXT) {
                activeBlockUrl = '/html5/assets/library/previews/text.png';
            }

            if (blokEditor.state1Look.value !== '' && blokEditor.state1Look.value != null) {
                activeBlockUrl = LibraryManager.textures.get(blokEditor.state1Look.value).get().baseTexture.imageUrl;
            }
        }

        if (blokEditor.state2Look) {
            if (blokEditor.state2Look.type === BlockAppearanceTypes.TEXT) {
                activeOtherBlockUrl = '/html5/assets/library/previews/text.png';
            }

            if (blokEditor.state2Look.value !== '' && blokEditor.state2Look.value != null) {
                activeOtherBlockUrl = LibraryManager.textures.get(blokEditor.state2Look.value).get().baseTexture.imageUrl;
            }
        }

        const defaultBlockUrl = LibraryManager.textures.get(newStateObject.texture).get().baseTexture.imageUrl;

        let page = null;
        if (sideBar.activeItem === SideBarItems.BLOK_EDITOR) {
            page = <BlokEditor closeSideBar={this.closeSideBar} setActiveItem={this.setActiveItem} activeItem={sideBar.activeItem} actionReactionAfterwards={actionReaction.afterwards} />;
        } else if (sideBar.activeItem === SideBarItems.ACTION_REACTION) {
            page = (
                <ActionReaction
                    closeSideBar={this.closeSideBar}
                    setActiveItem={this.setActiveItem}
                    activeItem={sideBar.activeItem}
                    actionReactionAfterwards={actionReaction.afterwards}
                    defaultBlockUrl={defaultBlockUrl}
                    activeOtherBlockUrl={activeOtherBlockUrl}
                    defaultBlockHue={newStateObject.hue}
                    activeOtherBlockHue={blokEditor.state2Look && blokEditor.state2Look.hue}
                />
            );
        } else if (sideBar.activeItem === SideBarItems.BLOK_CHANGE_STATE) {
            page = (
                <ChangeState
                    closeSideBar={this.closeSideBar}
                    setActiveItem={this.setActiveItem}
                    activeItem={sideBar.activeItem}
                    actionReactionAfterwards={actionReaction.afterwards}
                    defaultBlockUrl={defaultBlockUrl}
                    defaultBlockHue={newStateObject.hue}
                />
            );
        } else {
            page = null;
        }

        return (
            <>
                <div className="side-bar-items">
                    <div className="side-bar-item">
                        <CircleIconButton
                            active={sideBar.activeItem === SideBarItems.BLOK_EDITOR}
                            onClick={() => this.setActiveItem(SideBarItems.BLOK_EDITOR)}
                            src={activeBlockUrl}
                            iconStyle={{ filter: `hue-rotate(${blokEditor.state1Look && blokEditor.state1Look.hue * -1}deg)` }}
                        />
                    </div>
                    <div className="side-bar-item side-bar-item-action-reaction">
                        <CircleIconButton
                            active={sideBar.activeItem === SideBarItems.ACTION_REACTION}
                            onClick={() => this.setActiveItem(SideBarItems.ACTION_REACTION)}
                            src={`${settings.assetsPath}img/icons/obj_pijl.png`}
                            iconStyle={{ width: '2.5rem', height: '2.5rem', margin: '0.5rem' }}
                        />
                    </div>
                    {actionReaction.afterwards === ReactionAfterwards.ChangeState && (
                        <div className="side-bar-item">
                            <CircleIconButton
                                style={{ color: 'red' }}
                                active={sideBar.activeItem === SideBarItems.BLOK_CHANGE_STATE}
                                onClick={() => this.setActiveItem(SideBarItems.BLOK_CHANGE_STATE)}
                                src={activeOtherBlockUrl || defaultBlockUrl}
                                iconStyle={{ filter: `hue-rotate(${(blokEditor.state2Look ? blokEditor.state2Look.hue : newStateObject.hue) * -1}deg)` }}
                            />
                        </div>
                    )}
                </div>
                <div
                    className={`side-bar-page${
                        sideBar.activeItem !== SideBarItems.NONE &&
                        sideBar.activeItem !== SideBarItems.ACTIVE &&
                        sideBar.activeItem !== SideBarItems.BACKGROUND_DRAW &&
                        sideBar.activeItem !== SideBarItems.BACKGROUND_ERASE
                            ? ' side-bar-page-active'
                            : ''
                    }`}
                >
                    <div className="side-bar-content">{page}</div>
                </div>
            </>
        );
    };

    getBackgroundContent = () => {
        return <BackgroundEditor closeSideBar={this.closeSideBar} />;
    };

    render() {
        const { levelEditor } = this.props;

        let content = null;
        if (levelEditor.mode === LevelEditorModeEnum.DEFAULT) {
            content = this.getBlockUIContent();
        } else if (levelEditor.mode === LevelEditorModeEnum.BACKGROUND) {
            content = this.getBackgroundContent();
        }

        return <div className="side-bar">{content}</div>;
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    sideBar: state.sideBar,
    levelEditor: state.levelEditor,
    actionReaction: state.actionReaction,
    blokEditor: state.blokEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SideBar);
